var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#22B07D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0314 20.8324L28.8321 26.3264H32.4834C33.0447 26.3264 33.4997 26.7813 33.4997 27.3426C33.4997 27.9038 33.0447 28.3588 32.4834 28.3588H28.3783L27.0683 34.4131C26.9626 34.9015 26.5307 35.25 26.031 35.25C25.3545 35.25 24.8506 34.6255 24.9937 33.9643L26.2066 28.3588H18.9783L17.6656 34.4256C17.5615 34.9067 17.136 35.25 16.6438 35.25C15.9774 35.25 15.481 34.6348 15.622 33.9834L16.839 28.3588H12.7662C12.205 28.3588 11.75 27.9038 11.75 27.3426C11.75 26.7813 12.205 26.3264 12.7662 26.3264H17.2928L18.4921 20.8324H14.5166C13.9553 20.8324 13.5003 20.3775 13.5003 19.8162C13.5003 19.255 13.9553 18.8 14.5166 18.8H18.9459L20.2911 12.5747C20.3951 12.0935 20.8207 11.75 21.313 11.75C21.9794 11.75 22.4757 12.365 22.335 13.0164L21.0852 18.8H28.3134L29.656 12.5872C29.7616 12.0987 30.1936 11.75 30.6934 11.75C31.3699 11.75 31.8737 12.3743 31.7308 13.0355L30.4852 18.8H34.2338C34.795 18.8 35.25 19.255 35.25 19.8162C35.25 20.3775 34.795 20.8324 34.2338 20.8324H30.0314ZM27.8597 20.8324H20.6314L19.4321 26.3264H26.6603L27.8597 20.8324Z",
    fill: "#22B07D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLang);
export default __webpack_public_path__ + "static/media/lang.8d7f4ba555329a186b9de5bca88ce2d4.svg";
export { ForwardRef as ReactComponent };